import { useImperativeHandle, useState, forwardRef } from 'react';
import { Modal, Tabs } from 'antd';
import Detail from './Detail';
import './index.less';

const PublicityModal = forwardRef((_, ref) => {
  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    open: () => {
      setOpen(true);
    },
    close: onClose,
  }));

  const items = [
    { label: '视频宣传', key: '1', children: <Detail type="video" /> },
    { label: '其他宣传', key: '2', children: <Detail type="pdf" /> },
  ];

  return (
    <Modal
      title="四川省农业农村厅防范非法金融活动宣传"
      open={open}
      onCancel={onClose}
      footer={null}
      width={1200}
      className="publicity-modal"
      destroyOnClose
    >
      <Tabs items={items} />
    </Modal>
  );
});

export default PublicityModal;
